var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTargetNotMet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.61 30.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e32329;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    className: "cls-1",
    d: "M12.45,23.63c-4.63,0-8.39-3.75-8.39-8.39S7.81,6.86,12.45,6.86c1.35,0,2.68.33,3.88.96l1.23-1.23c-1.54-.92-3.31-1.41-5.11-1.41-5.56,0-10.06,4.52-10.05,10.08,0,5.56,4.52,10.06,10.08,10.05.47,0,.94-.03,1.41-.1-.25-.52-.45-1.06-.59-1.62-.28.03-.56.05-.84.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    className: "cls-1",
    d: "M20.4,12.58c.52-.09,1.04-.14,1.57-.13h.14c-.23-.81-.57-1.58-.99-2.3l-1.23,1.23c.2.39.38.79.51,1.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    className: "cls-1",
    d: "M12.45,10.77c.28,0,.56.03.84.09l1.35-1.36c-.7-.27-1.44-.41-2.19-.41-3.4,0-6.15,2.75-6.15,6.15s2.75,6.15,6.15,6.15c.19,0,.38-.01.57-.03,0-.57.05-1.15.17-1.71-.24.05-.49.07-.74.07-2.47,0-4.47-2-4.47-4.47s2-4.47,4.47-4.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    className: "cls-1",
    d: "M20.32,8.57s.02-.02.03-.03h2.45c.22,0,.44-.09.59-.24l2.24-2.24c.33-.33.33-.86,0-1.19-.16-.16-.37-.25-.59-.25h-1.96v-1.96c0-.46-.37-.84-.84-.84-.22,0-.44.09-.59.25l-2.24,2.24c-.16.16-.25.37-.25.59v2.45s-.02.02-.03.03l-5.81,5.81c-1.14-.49-2.46.03-2.95,1.17-.49,1.14.03,2.46,1.17,2.95,1.14.49,2.46-.03,2.95-1.17.24-.56.24-1.19,0-1.76l5.81-5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    className: "cls-1",
    d: "M21.96,14.13c-4.01,0-7.27,3.26-7.27,7.27,0,4.01,3.26,7.27,7.27,7.27,4.01,0,7.27-3.25,7.27-7.27,0-4.01-3.26-7.26-7.27-7.27M24.65,22.9c.34.32.35.85.04,1.19-.32.34-.85.35-1.19.04-.01-.01-.02-.02-.04-.04l-1.5-1.5-1.5,1.5c-.33.33-.86.32-1.19,0-.32-.33-.32-.85,0-1.18l1.5-1.5-1.5-1.5c-.33-.33-.33-.86,0-1.19s.86-.33,1.19,0l1.5,1.5,1.5-1.5c.33-.33.86-.33,1.19,0,.33.33.33.86,0,1.19l-1.5,1.5,1.5,1.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetNotMet);
export default __webpack_public_path__ + "static/media/Target Not Met.467df17ff95600abbfcbd09097fbb0b9.svg";
export { ForwardRef as ReactComponent };